module.exports = __webpack_public_path__ + "static/media/toolbox.0c788597.svg";